import AdminApplications from "../../components/Admin/AdminApplications";
import DashboardLayout from "../../components/Layout/DashboardLayout";
import {
  applicationStageMap,
  applicationStatusMap,
} from "../../config/applicationStatusConfig";

const OfficersPendingApplications = () => {
  const excludedStages = ["user"];

  const stages = Object.entries(applicationStageMap)
    .filter(([key]) => !excludedStages.includes(key))
    .map(([, value]) => value.value);

  const statuses = Object.values(applicationStatusMap).map((s) => s.value);
  
  return (
    <DashboardLayout pageTitle="Application" mainClass="p-6">
      <AdminApplications
        title="Officers Pending Applications"
        status={statuses}
        stage={stages}
      />
    </DashboardLayout>
  );
};

export default OfficersPendingApplications;
